<app-topheader></app-topheader>
<div class="scrollingcontainer ">

    <div class="container">

        <app-ship-name></app-ship-name>
        <div class="tenpxtop"></div>
        <app-longgoldbar></app-longgoldbar>

        <app-deck-plans imagetype="map"></app-deck-plans>

    </div>
</div>
<app-bottommenu></app-bottommenu>